import * as React from 'react';
import { Typography, Box, Container, Grid, Card, CardContent, Avatar } from '@mui/material';
import { SectionContainer } from './Components/styles';
import ScrollAnimation from './Components/ScrollAnimation';

export default function InfluencerReview() {

    const testimonialsData = [
        {
            name: "Marina Petrichenko",
            designation: "Web3 Marketing & Growth specialist, +20k followers",
            review: "Scriptu is a game-changer for LinkedIn—simplifies posting and elevates impact. It helps craft deeply resonant messages and preview their influence, transforming engagement strategy efficiently.",
            avatar: "https://media.licdn.com/dms/image/v2/D4D03AQEQ6-kX5bpEcg/profile-displayphoto-shrink_400_400/B4DZXHxHfxG4Ag-/0/1742813297515?e=1749686400&v=beta&t=ryuAnc-pYAXlsh7S5l2mPXx-f1ri2DDBpQ59B42lTsQ",
        },
        {
            name: "Cesar Rodriguez",
            designation: "CTO at IQ.wiki, +16k followers",
            review: "Scriptu elevates LinkedIn posting beyond simplicity to strategic content creation. Its AI insights refine our brand message, making every post a key asset for impactful tech leadership.",
            avatar: "https://media.licdn.com/dms/image/v2/D4D03AQE7zNNfxjss3Q/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1724070731096?e=1745452800&v=beta&t=pwCgTCaGm9vBg0GgrqWla2uV-5Nob2s08I3Ibj0FBMc",
        },
    ];

    return (
        <div id="whyus">
            <Container maxWidth="lg" sx={{ mt: 3, mb: 3 }}>
                <SectionContainer>
                    <ScrollAnimation animateIn="flipInX" delay={0.3}>
                        <span
                            style={{
                                borderRadius: '50px',
                                background: '#ec0c52',
                                boxShadow: '0px 2px 4px 0px rgba(27, 42, 82, 0.2)',
                                display: 'inline-block',
                                color: '#fff',
                                fontSize: '14px',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                padding: '0 25px',
                                height: '36px',
                                lineHeight: '36px',
                                marginBottom: '50px',
                            }}
                        >    Customer Testimonials
                        </span>

                        <Typography variant="h3" sx={{ fontSize: '44px', color: '#000135', fontWeight: 700, lineHeight: 1.13, letterSpacing: '-1.76px', mb: 10 }}>
                            They Love Scriptu, {"You'll"} Cherish the Results ❤️
                        </Typography>
                    </ScrollAnimation>

                    <Grid container spacing={3} >
                        {testimonialsData.map((item, index) => (
                            <Grid item xs={12} sm={6} md={6} key={index}>
                                <ScrollAnimation animateIn="fadeInLeft" delay={0.3 + (index / 10)}>

                                    <Card sx={{ boxShadow: '0 0 10px 3px #f8312f', borderRadius: '20px', minHeight: '310px' }}>
                                        <CardContent sx={{ minHeight: '110px' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '20px', gap: 2 }}>
                                                <Avatar alt={item.name} src={item.avatar} sx={{ width: 80, height: 80 }} />
                                                <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                                                    <Typography sx={{ fontWeight: 'bold', color: '#000135', fontSize: '1.8rem' }}>{item.name}</Typography>
                                                    <Typography sx={{ fontSize: '1rem', color: '#f8312f' }}>{item.designation}</Typography>
                                                </Box>
                                            </Box>
                                            <Typography variant="h5" gutterBottom sx={{
                                                marginTop: '20px', marginBottom: 0, fontSize: '24px',
                                                fontWeight: 400, lineHeight: '140%', textAlign: 'left'
                                            }}>
                                                {item.review}
                                            </Typography>
                                        </CardContent>
                                    </Card>

                                </ScrollAnimation>
                            </Grid>
                        ))}
                    </Grid>
                </SectionContainer>
            </Container>
        </div >
    );
}
